import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { IconButton } from '../CommonComponents/OPL/IconButton/IconButton';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { AccountDistributionOrderOptionDTO } from './api/useAccountDistributionOptionsQuery';

export type AccountDistributionOrderItemId = string;

interface SortableAccountDistributionItemProps extends AccountDistributionOrderOptionDTO {
  onDelete(id: AccountDistributionOrderItemId): void;
}

export const SortableAccountDistributionItem = ({
  id,
  label,
  taxStatus,
  onDelete,
}: SortableAccountDistributionItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      css={({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.space[8],
        border: `1px solid ${theme.colors.neutral[100]}`,
        borderRadius: theme.radii.medium,
        backgroundColor: theme.colors.neutral[50],
      })}
    >
      <Box display="flex" alignItems="center" gridGap={8}>
        <div>
          <Text fontWeight={600}>{label}</Text>
          <Text fontSize="small">{taxStatus}</Text>
        </div>
      </Box>

      <Box display="flex" alignItems="center" gridGap={4}>
        <IconButton
          icon="far fa-times-circle"
          variant="subtleInactive"
          onClick={() => onDelete(id)}
          aria-label={`Remove ${label} from the list`}
        />

        <IconButton
          icon="fas fa-grip-vertical"
          variant="subtleInactive"
          style={{ cursor: 'grab' }}
          aria-label="Drag to reorder"
          {...attributes}
          {...listeners}
        >
          Drag
        </IconButton>
      </Box>
    </Box>
  );
};
